// src/pages/Contact/ContactPage.jsx
import { useMemo } from "react";
import { PageWrap, Section, OrnamentGeneral } from "./ContactPageStyles";

import ContactInfo from "../../components/ContactInfo/ContactInfo";
import ContactHero from "../../components/ContactHero/ContactHero";
import MapBanner from "../../components/MapBanner/MapBanner";
import ContactForm from "../../components/ContactForm/ContactForm";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO/SEO";

export default function ContactPage() {
  const { t } = useTranslation("common");

  const brand = t("Restaurant LaFontanella");
  const address = "Bulevardul Mihai Săulescu nr.111, Predeal, România";
  const mapsLatLng = { lat: 45.4986, lng: 25.575 };
  const phone = "+40 771 410 920";
  const email = "lafontanellapredeal@gmail.com";

  const hours = useMemo(
    () => ({
      title: t("contact.program"),
      subtitle: t("contact.booking.note"),
      days: `${t("contact.days.mon")} – ${t("contact.days.sun")}`,
      start: "09:00",
      end: "23:00",
      call: phone,
    }),
    [t, phone]
  );

  return (
    <PageWrap>
      <SEO
        title="Contact - La Fontanella Predeal"
        description="Contactează restaurantul La Fontanella din Predeal. Rezervă o masă, comandă mâncare sau află mai multe despre livrările noastre."
      />

      <ContactHero brand={brand} ariaLabel={t("contact.aria")} />

      <MapBanner
        center={mapsLatLng}
        markerTitle={brand}
        ariaLabel={t("contact.address.openMaps")}
      />

      <OrnamentGeneral />

      <Section aria-label={t("contact.aria")}>
        <ContactForm
          i18n={{
            // etichete câmpuri
            name: t("contact.form.name"),
            email: t("contact.form.email"),
            phone: t("contact.form.phone"),
            subject: t("contact.form.subject"),
            message: t("contact.form.message"),

            // placeholders
            placeholders: {
              name: t("contact.form.placeholders.name"),
              email: t("contact.form.placeholders.email"),
              phone: t("contact.form.placeholders.phone"),
              subject: t("contact.form.placeholders.subject"),
              message: t("contact.form.placeholders.message"),
            },

            // acțiuni
            actions: {
              submit: t("contact.form.actions.submit"),
              sending: t("contact.form.actions.sending"),
            },

            // erori
            errors: {
              nameRequired: t("contact.form.errors.nameRequired"),
              emailInvalid: t("contact.form.errors.emailInvalid"),
              phoneRequired: t("contact.form.errors.phoneRequired"),
              messageRequired: t("contact.form.errors.messageRequired"),
            },

            // diverse
            helperPhone: t("contact.form.helperPhone"),
            submitSuccess: t("contact.form.submitSuccess"),
            submitError: t("contact.form.submitError"),
          }}
          brand={brand}
          email={email}
          phone={phone}
        />
      </Section>

      <OrnamentGeneral />

      <ContactInfo
        brand={brand}
        address={address}
        mapsUrl="https://www.google.com/maps?q=Mihai+Săulescu+111,+Predeal"
        accent="#d4af37"
        labels={{
          addressTitle: t("contact.address.title"),
          location: t("contact.address.location"),
          openMaps: t("contact.address.openMaps"),
          bookingTitle: t("contact.booking.title"),
          bookingPhone: t("contact.booking.phone"),
          bookingCta: t("contact.booking.cta"),
          bookingCallAria: t("contact.booking.callAria"),
          program: t("contact.program"),
          closed: t("contact.hours.closed"),
        }}
        hours={hours}
      />
      <OrnamentGeneral />
    </PageWrap>
  );
}
